import { Button, ButtonProps } from "antd";
import React from "react";
import { classNames } from "src/common/classNames";
import styles from "./SolidButton.module.less";

export const SolidButton: React.FC<ButtonProps> = ({ className, ...props }) => (
  <Button {...props} className={classNames([styles.button, className])} />
);
